import { StatementPayload, createLangString } from '@/app/tracking/xapi/tincan/client';

interface ExamFailedStatementParams {
  id: string;
  title: string;
  description?: string;
}

export function createExamFailedStatement(params: ExamFailedStatementParams) {

  const statement: StatementPayload = {
    verb: {
      id: 'http://adlnet.gov/expapi/verbs/failed',
      display: {
        'en-US': 'failed'
      }
    },
    object: {
      objectType: 'Activity',
      id: params.id,
      definition: {
        type: 'http://adlnet.gov/expapi/activities/assessment',
        name: createLangString(params.title),
        description: params.description ? createLangString(params.description) : undefined
      }
    }
  };

  return statement;
}
